import React from 'react'
import { THtmlElementHeading } from '@/types/HtmlElements'

type TProps = {
  children: React.ReactNode
  tag: THtmlElementHeading
  className: string
}

function SectionSubHeading({ children, tag, className }: TProps) {
  const Tag = tag
  const classes =
    'mt-1 text-base font-normal text-gray-700 max-w-[680px] ' + className

  return <Tag className={classes}>{children}</Tag>
}

export default SectionSubHeading
